import { render, staticRenderFns } from "./HeaderTemplate.vue?vue&type=template&id=58edd572&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&lang=js"
import style0 from "./HeaderTemplate.vue?vue&type=style&index=0&id=58edd572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58edd572",
  null
  
)

export default component.exports